import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { notification } from "antd";
import { beep, translate } from "utils";
import { getTotalUnreadNotificationsAsync } from "features/notification/redux/notification.slice";
import { onMessage } from "firebase/messaging";
import { messaging } from "firebase-init";
import _ from "lodash";
import { NOTIFICATION_TYPE } from "constants/constants";
import { uuid } from "short-uuid";
import { APP_PATH } from "constants/path";
import { NOTIFICATION_FIELDS } from "./Notifications";
import { selectLang } from "store/lang/langSlice";

const NotificiationItem = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [apiNotification, contextHolder] = notification.useNotification();
	const lang = useSelector(selectLang);

	const formatDate = (date?: string) => {
		const parts = date?.split("-");
		return parts?.[2] + "/" + parts?.[1] + "/" + parts?.[0];
	};

	messaging.then(msg => {
		if (msg) {
			onMessage(msg, payload => {
				if (NOTIFICATION_FIELDS[payload.data?.title as unknown as string]) {
					beep("iphone_noti");
					const payloadData = JSON.parse(payload.data?.data ?? "");
					const notificationData = payloadData?.data;
					apiNotification.info({
						key: payloadData.id,
						duration: 10,
						onClick: () => {
							switch (payload.data?.type) {
								case NOTIFICATION_TYPE.created_car:
									navigate(`${APP_PATH.cars}/${notificationData?.carId}`);
									break;
								case NOTIFICATION_TYPE.merchant_just_edited_information_of_a_car:
									navigate(`${APP_PATH.cars}/${notificationData?.carId}`);
									break;
								case NOTIFICATION_TYPE.staff_new_test_drive:
									navigate(
										`transaction-appointment/${notificationData?.bookingId}`,
									);
									break;
								case NOTIFICATION_TYPE.staff_cancel_test_by_customer:
									navigate(
										`transaction-appointment/${notificationData?.bookingId}`,
									);
									break;
								case NOTIFICATION_TYPE.merchant_add_car_request:
									navigate(
										`/request-services/transaction-merchant-request/${notificationData?.merchantRequestId}`,
									);
									break;
								case NOTIFICATION_TYPE.merchant_cancel_car_request:
									navigate(
										`/request-services/transaction-merchant-request/${notificationData?.merchantRequestId}`,
									);
									break;
								case NOTIFICATION_TYPE.merchant_add_service_request:
									navigate(
										`/request-services/transaction-merchant-request/${notificationData?.merchantRequestId}`,
									);
									break;
								case NOTIFICATION_TYPE.merchant_cancel_service_request:
									navigate(
										`/request-services/transaction-merchant-request/${notificationData?.merchantRequestId}`,
									);
									break;
								case NOTIFICATION_TYPE.customer_create_new_customer_request:
									navigate(
										`${APP_PATH.contactSupports}/${notificationData?.id}`,
									);
									break;
								case NOTIFICATION_TYPE.customer_register_collaborator:
									navigate(
										`${APP_PATH.collaborators}/${notificationData?.formId}`,
									);
									break;
								case NOTIFICATION_TYPE.staff_new_rent_appointment:
									navigate(
										`${APP_PATH.transactionAppointment}/${notificationData?.bookingId}`,
									);
									break;
								case NOTIFICATION_TYPE.merchant_updated_rent_car:
									navigate(`${APP_PATH.cars}/${notificationData?.carId}`);
									break;
								case NOTIFICATION_TYPE.merchant_created_rent_car:
									navigate(`${APP_PATH.cars}/${notificationData?.carId}`);
									break;
								case NOTIFICATION_TYPE.staff_customer_cancel_rent_appointment:
									navigate(
										`${APP_PATH.transactionAppointment}/${notificationData?.bookingId}`,
									);
									break;
								case NOTIFICATION_TYPE.merchant_completed_rental_purchase:
									navigate(
										`${APP_PATH.transactionPurchase}/${notificationData?.purchaseOrderId}`,
									);
									break;
								case NOTIFICATION_TYPE.car_wash_merchant_created:
									navigate(
										`${APP_PATH.carCares}/${notificationData?.carWashId}`,
									);
									break;
								case NOTIFICATION_TYPE.car_wash_merchant_updated:
									navigate(
										`${APP_PATH.carCares}/${notificationData?.carWashId}`,
									);
									break;
								case NOTIFICATION_TYPE.merchant_created_car_wash_post_to_staffs:
									navigate(
										`${APP_PATH.communityPosts}/${notificationData?.postId}`,
									);
									break;
								case NOTIFICATION_TYPE.merchant_created_voucher_to_staffs:
									navigate(
										`${APP_PATH.loyaltyCustomerVouchersOfMerchant}/${notificationData?.voucherId}`,
									);
									break;
								case NOTIFICATION_TYPE.merchant_edited_voucher_to_staffs:
									navigate(
										`${APP_PATH.loyaltyCustomerVouchersOfMerchant}/${notificationData?.voucherId}`,
									);
									break;
								case NOTIFICATION_TYPE.merchant_update_car_store_to_staffs:
									navigate(
										`${APP_PATH.stores}/${notificationData?.carStoreId}`,
									);
									break;
								case NOTIFICATION_TYPE.car_loan_request_created_to_staff:
									navigate(
										`${APP_PATH.loanApplications}/${notificationData?.formRequestId}`,
									);
									break;
							}
							notification.close(payloadData.id);
						},
						message: (
							<p className="break-words font-bold text-sky-600}">
								{translate((payload.data?.title || "").replace(/\.$/, ""))}
							</p>
						),
						description: (
							<div className="text-xs text-stone-900">
								{(() => {
									if (
										payload.data?.type ===
										NOTIFICATION_TYPE.merchant_update_car_store_to_staffs
									) {
										return (
											<p>
												{translate(payload.data?.body?.split("\n")[0] || "")}
											</p>
										);
									}
									return null;
								})()}

								{NOTIFICATION_FIELDS[payload.data?.title ?? ""].length
									? NOTIFICATION_FIELDS[payload.data?.title ?? ""]?.map(
											(element: any) => {
												let textValue = "";
												if (
													element.displayName === "Time" &&
													element.path &&
													!element.customSlot
												) {
													textValue =
														translate(
															_.get(notificationData, element.path.time),
														) +
														` ${translate("on")} ` +
														formatDate(
															_.get(notificationData, element.path.date),
														);
												} else if (
													element.transCarNames &&
													notificationData.carTranslations
												) {
													textValue = element.transCarNames(
														notificationData,
														lang,
													);
												} else if (
													notificationData.voucherNameTranslation &&
													element.displayName === "Voucher"
												) {
													textValue =
														notificationData.voucherNameTranslation[lang];
												} else if (element.customSlot) {
													textValue = element.customSlot(notificationData);
												} else {
													textValue = _.get(notificationData, element.path);
												}

												return (
													<div key={uuid()}>
														{`${translate(element.displayName)}: `}
														<span className="font-semibold">{textValue}</span>
													</div>
												);
											},
									  )
									: payload.data?.body}
							</div>
						),
						placement: "topRight",
					});
					dispatch(getTotalUnreadNotificationsAsync({}));
				}
			});
		}
	});

	return <div>{contextHolder}</div>;
};

export default NotificiationItem;
